import { Hideable } from "shared/UI/Hideable/Hideable";
import { LeaderboardsList } from "../../../Wellbeing/components/LeaderboardsList/LeaderboardsList";
import { Modal, ModalBody, ModalFooter } from "shared/UI/Modal/Modal";
import Button from "shared/UI/Buttons/Button";
import classNames from "classnames";
import { t } from "i18next";
import { useGetUserLeaderboardsFunctionRequest } from "shared/request/myHealthyAdvantageApi";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { ViewStateWrapper } from "UIPalette/ViewStateWrapper/ViewStateWrapper";
import PageTitle from "UIPalette/PageTitle/PageTitle";
import { trackBtnClicks } from "core/monitoring/Events";
import { PageHeader } from "UIPalette/PageHeader/PageHeader";
import { Input } from "shared/UI/Input/Input";

export const LeaderboardsHome = () => {
  const navigate = useNavigate();
  const [joinModalOpen, setJoinModalOpen] = useState(false);
  const [existingLeaderboardCode, setExistingLeaderboardCode] = useState("");
  const { data: userLeaderboards, isLoading, error, mutate } = useGetUserLeaderboardsFunctionRequest({});
  const hasActiveLeaderboards = !isLoading && !error && userLeaderboards?.active && userLeaderboards!.active.length > 0;
  const hasCompletedLeaderboards = !isLoading && !error && userLeaderboards?.completed && userLeaderboards!.completed.length > 0;

  const handleClickJoin = () => {
    trackBtnClicks("join_leaderboard");
    setJoinModalOpen(true);
  };

  const handleClickCreate = () => {
    trackBtnClicks("create_leaderboard");
    navigate("create");
  };

  return (
    <>
      <PageTitle title={t("pageTitle.leaderboards.home")} />
      <PageHeader title={t("home.leaderboards.activeLeaderboardsTitle")} hideForMobile />
      <p role="note" className="col-start-1 sm:col-span-2">
        {t("leaderboards.home.description")}
      </p>
      <div className="flex flex-col sm:flex-row mt-6 gap-4 justify-between">
        <Button
          text={t("leaderboards.home.createButton")}
          onClick={handleClickCreate}
        />
        <Button
          variant="secondary"
          text={t("leaderboards.home.joinButton")}
          onClick={handleClickJoin}
        />
      </div>
      <ViewStateWrapper loading={isLoading} error={!!error} errorMessage={t("leaderboards.errors.load")} onRetry={mutate} isFullScreenView={true}>
        {hasActiveLeaderboards && (
          <div className="col-start-1 my-6">
            <LeaderboardsList leaderboards={userLeaderboards?.active} title={t("leaderboards.home.activeTitle")} />
          </div>
        )}
        {hasCompletedLeaderboards && (
          <div className={classNames("my-6", { "col-start-1": !hasActiveLeaderboards })}>
            <LeaderboardsList leaderboards={userLeaderboards?.completed} title={t("leaderboards.home.completedTitle")} />
          </div>
        )}
        <Hideable hidden={!joinModalOpen}>
          <Modal title={t("leaderboards.joinModal.title")} width="xs" hideDismiss close={() => setJoinModalOpen(false)}>
            <ModalBody>
              <Input
                type="text"
                onChange={(val) => setExistingLeaderboardCode(val.currentTarget.value)}
                value={existingLeaderboardCode}
                placeholder={t("leaderboards.joinModal.enterCodePlaceholder")}
              />
            </ModalBody>
            <ModalFooter>
              <div className="flex flex-col gap-4 justify-between">
                <Button
                  text={t("leaderboards.joinModal.preview")}
                  onClick={() => navigate(`preview/${existingLeaderboardCode}`)}
                />
                <Button
                  variant="text"
                  text={t("leaderboards.joinModal.back")}
                  onClick={() => setJoinModalOpen(false)}
                />
              </div>
            </ModalFooter>
          </Modal>
        </Hideable>
      </ViewStateWrapper>
    </>
  );
};
